import inventoryApi from "api/inventoryApi";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export const useInventoryNew = () => {
    const [invGoodsInfo, setInvGoodsInfo] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({});
    const isFirstRun = useRef(true);
    const navigate = useNavigate();


    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }

        (async function RegisterNewInvGoods() {
            try {
                if (!invGoodsInfo?.GoodsName) return;
                setIsLoading(true);
                const formData = new FormData();
                formData.append("gId", invGoodsInfo?.GoodsID || 1);
                formData.append("gsId", invGoodsInfo?.GoodsSubID || 1)
                formData.append("gName", invGoodsInfo?.GoodsName || '')
                formData.append("gKana", invGoodsInfo?.GoodsKana || '')
                formData.append("gSize", invGoodsInfo?.GoodsSize || '')
                formData.append("stkQ", invGoodsInfo?.StockQuantity || 0)
                formData.append("stkQMemo", invGoodsInfo?.StockQuantityMemo || '')
                formData.append("shfName", invGoodsInfo?.ShelfName || '')
                formData.append("invGMemo", invGoodsInfo?.InvGoodsMemo || '')
                formData.append("mGImgUrl", invGoodsInfo?.MGoodsImageUrl || '')
                formData.append("gImgFile[]", invGoodsInfo?.GoodsImage || '')
                const dtResponse = await inventoryApi.addNewInvGoods(formData);
                const newInvGoodsID = dtResponse?.data['invGoodsID'] ?? '';
                if (newInvGoodsID < 1) {
                    throw Error("登録が失敗しました。");
                }

                const msg = { type: 'success', contents: ['在庫商品を登録しました。'] };
                setMessage(msg);
                //Navigate to Site List
                navigate(`/inventory`, { replace: true });

            } catch (err) {
                const msg = { type: 'error', contents: [err.message || '登録が失敗しました。'] };
                setMessage(msg);
            } finally {
                setIsLoading(false);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invGoodsInfo]);

    return { setInvGoodsInfo, isLoading, setIsLoading, message, setMessage, navigate };

}